export const releaseInfo = '27-10-2026 16:02';
